import api from "./api";

class PianoDiPagamentoManager {
    pianoDiPagamento(pdf_id: number | string, config?: any) {
        return api.get(`/piano_di_pagamento/${pdf_id}`, config)
    }

    create(sottoprogetto_id: number | string, fornitore_id: number | string, data: any) {
        return api.post(`sottoprogetti/${sottoprogetto_id}/piano_di_pagamento/${fornitore_id}/`, data)
    }

    sottoprogettoFornitore(sottoprogetto_id: number | string, fornitore_id: number | string) {
        return api.get(`sottoprogetti/${sottoprogetto_id}/fornitore/${fornitore_id}/piano_di_pagamento`)
    }
    clone(piano_di_pagamento_id: number | string) {
        return api.get(`piano_di_pagamento/${piano_di_pagamento_id}/clone`)
    }

    delete(piano_di_pagamento_id: number | string) {
        return api.delete(`piano_di_pagamento/${piano_di_pagamento_id}`)
    }


    update(pdf_id: number | string, data: any) {
        return api.put(`/piano_di_pagamento/${pdf_id}/`, data)
    }

    retrieve = this.pianoDiPagamento
    list = this.sottoprogettoFornitore
    paginatedList = this.sottoprogettoFornitore

}

const pianoDiPagamentoManager = new PianoDiPagamentoManager()

export default pianoDiPagamentoManager

